import { render } from "./GastronomyNearbyCarousel.vue?vue&type=template&id=3c06f6ee&scoped=true&ts=true"
import script from "./GastronomyNearbyCarousel.vue?vue&type=script&lang=ts"
export * from "./GastronomyNearbyCarousel.vue?vue&type=script&lang=ts"

import "./GastronomyNearbyCarousel.vue?vue&type=style&index=0&id=3c06f6ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c06f6ee"]])

export default __exports__